import React from 'react';
import { Stack } from '@mui/material';
import { ListEmpty } from 'components/shared/List';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { AdminDashboardOption } from '../../types';
import { AdminDashboardListItem } from './AdminDashboardListItem';

interface Props {
  dashboardOptionList: AdminDashboardOption[];
}

export const AdminDashboardList = ({ dashboardOptionList }: Props) => {
  return (
    <RenderWithCondition condition={!!dashboardOptionList.length} fallBack={<ListEmpty />}>
      <Stack gap="0.5rem">
        {dashboardOptionList.map(dashboardOption => (
          <AdminDashboardListItem key={dashboardOption.id} dashboardOption={dashboardOption} />
        ))}
      </Stack>
    </RenderWithCondition>
  );
};
